<template>
  <div class="mistakesigninaddress-div">
    <div class="mistakesigninaddress-top">
      <div class="top-logo">
        <span class="iconfont icon-tixingshixin"></span>
      </div>
      <div class="top-infodiv">
        <div class="top-notice">{{attendInfo.name || ""}}学员，请您前往&nbsp;<span class="top-notice-address">{{ addressInfo.place || "" }}</span>&nbsp;签到！</div>
        <div class="top-currentlocation">当前位置：{{currentPlace || ""}}</div>
      </div>
    </div>
    <div class="mistakesigninaddress-coursetitle">您的课程信息如下：</div>
    <div class="mistakesigninaddress-normalinfo">
      <div class="info-title iconfont icon-rili"></div>
      <div class="info-text">{{ dsf.date.format(addressInfo.beginDateTime, "mm月dd日 hh:ii")}}</div>
    </div>
    <div class="mistakesigninaddress-normalinfo">
      <div class="info-title iconfont icon-address"></div>
      <div class="info-text">{{ addressInfo.place || "" }}</div>
    </div>
    <div class="mistakesigninaddress-normalinfo">
      <div class="info-title iconfont icon-xxkc"></div>
      <div class="info-text">{{ addressInfo.name || "" }}</div>
    </div>
    <div class="mistakesigninaddress-normalinfo">
      <div class="info-title iconfont icon-jiaoshi"></div>
      <div class="info-text">{{ addressInfo.speakerText || "" }}</div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{

    }
  },
  props:{
    attendInfo: {
      type: Object,
      default: () => {},
    },
    addressInfo: {
      type: Object,
      default: () => {},
    },
    currentPlace: {
      type: String,
      default: "",
    }
  }
}
</script>

<style>

</style>